import Vue from 'vue';

Vue.component('stock-transfer-index', () =>
    import(/* webpackChunkName: 'stock-transfer-index' */ './stock-transfer-index.vue'),
);
